import { SidebarNavigationSectionType } from "@/types/navigation";

import { current } from "./current";
import dashboard from "./dashboard";
import settings from "./settings";
import tables from "./tables";

const sidebarMenuItems: SidebarNavigationSectionType[] = [
  dashboard,
  current,
  tables,
  settings,
];
export default sidebarMenuItems;
